// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountTypeController from "./account_type_controller"
application.register("account-type", AccountTypeController)

import CaptchaRefreshController from "./captcha_refresh_controller"
application.register("captcha-refresh", CaptchaRefreshController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DisableOnSubmitController from "./disable_on_submit_controller"
application.register("disable-on-submit", DisableOnSubmitController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DynamicListController from "./dynamic_list_controller"
application.register("dynamic-list", DynamicListController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IconPreviewController from "./icon_preview_controller"
application.register("icon-preview", IconPreviewController)

import MobileSidebarController from "./mobile_sidebar_controller"
application.register("mobile-sidebar", MobileSidebarController)

import MoneyController from "./money_controller"
application.register("money", MoneyController)

import NavImportController from "./nav_import_controller"
application.register("nav-import", NavImportController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import PageSizeController from "./page_size_controller"
application.register("page-size", PageSizeController)

import PasskeyPromptController from "./passkey_prompt_controller"
application.register("passkey-prompt", PasskeyPromptController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ProfitCalculatorController from "./profit_calculator_controller"
application.register("profit-calculator", ProfitCalculatorController)

import ResponsiveTableController from "./responsive_table_controller"
application.register("responsive-table", ResponsiveTableController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import WebauthnController from "./webauthn_controller"
application.register("webauthn", WebauthnController)
